// routes/routes.js
import { lazy } from "react";

// Lazy-loaded components
const Login = lazy(() => import("../pages/Login"));
const Home = lazy(() => import("../pages/Home"));
const AboutFull = lazy(() => import("../pages/AboutFull"));
const Category = lazy(() => import("../pages/category/Category"));
const Coronary = lazy(() => import("../pages/category/Coronarys"));
const ProdXl = lazy(() => import("../pages/produtcs/ProdXl"));
const ProdRe = lazy(() => import("../pages/produtcs/ProdRe"));
const ProdEvro = lazy(() => import("../pages/produtcs/ProdEvro"));
const ProdEver = lazy(() => import("../pages/produtcs/ProdEver"));
const ProdForce = lazy(() => import("../pages/produtcs/ProdForce"));
const ProdSum = lazy(() => import("../pages/produtcs/ProdSum"));
const ProdPrimum = lazy(() => import("../pages/produtcs/ProdPrimum"));
const ProdPointer = lazy(() => import("../pages/produtcs/ProdPointer"));
const ProdLg = lazy(() => import("../pages/produtcs/ProdLg"));
const ProdAperto = lazy(() => import("../pages/produtcs/ProdAperto"));
const Peripheral = lazy(() => import("../pages/category/Peripheral"));
const Accessories = lazy(() => import("../pages/category/Accessories"));
const Contact = lazy(() => import("../pages/Contact"));
const Carrer = lazy(() => import("../pages/Carrer"));
const News = lazy(() => import("../pages/News"));
const NewsAdmin = lazy(() => import("../pages/admin/NewsAdmin"));
const JobAdmin = lazy(() => import("../pages/admin/JobAdmin"));
const DetailNews = lazy(() => import("../pages/admin/DetailNews"));
const DetailJob = lazy(() => import("../pages/admin/DetailJob"));
const NewsFull = lazy(() => import("../pages/NewsFull"));
const CareerFull = lazy(() => import("../pages/CareerFull"));
const ContactAdmin = lazy(() => import("../pages/admin/ContactAdmin"));
const Dashboard = lazy(() => import("../pages/admin/Dashboard"));
const NotFound = lazy(() => import("../components/NotFound"));

const publicRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/about",
    element: <AboutFull />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/career",
    element: <Carrer />,
  },
  {
    path: "/career/:slug",
    element: <CareerFull />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/news/:slug",
    element: <NewsFull />,
  },
  {
    path: "/category/coronary",
    element: <Coronary />,
  },
  {
    path: "/category/coronary/Xlimus-DES",
    element: <ProdXl />,
  },
  {
    path: "/category/coronary/Evrocross",
    element: <ProdEvro />,
  },
  {
    path: "/category/coronary/Restore-DEB",
    element: <ProdRe />,
  },
  {
    path: "/category/coronary/Everest",
    element: <ProdEver />,
  },
  {
    path: "/category/coronary/Force",
    element: <ProdForce />,
  },
  {
    path: "/category/coronary/Summit",
    element: <ProdSum />,
  },
  {
    path: "/category/peripheral",
    element: <Peripheral />,
  },
  {
    path: "/category/peripheral/Legflow",
    element: <ProdLg />,
  },
  {
    path: "/category/peripheral/Aperto",
    element: <ProdAperto />,
  },
  {
    path: "/category/accessories",
    element: <Accessories />,
  },
  {
    path: "/category/accessories/Primum",
    element: <ProdPrimum />,
  },
  {
    path: "/category/accessories/Pointer",
    element: <ProdPointer />,
  },
  {
    path: "/",
    element: <Home />,
  },
];

const privateRoutes = [
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/news-admin",
    element: <NewsAdmin />,
  },
  {
    path: "/news-admin/:slug",
    element: <DetailNews />,
  },
  {
    path: "/job-admin",
    element: <JobAdmin />,
  },
  {
    path: "/job-admin/:slug",
    element: <DetailJob />,
  },
  {
    path: "/contact-admin",
    element: <ContactAdmin />,
  },
  {
    path: "/dashboard/*",
    element: <NotFound />,
  },
  {
    path: "/news-admin/*",
    element: <NotFound />,
  },
  {
    path: "/job-admin/*",
    element: <NotFound />,
  },
  {
    path: "/contact-admin/*",
    element: <NotFound />,
  },
];

export { publicRoutes, privateRoutes };
